module.exports = __webpack_public_path__ + "static/media/GearIcon.16319d7a.svg";